@if (isVisible) {
    <div class="flex flex-col gap-2">
        <loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>
        <div class="flex flex-col gap-4 items-center justify-center">
            @if (!isLoading && loadingSuccess) {
                @if (magicCards && magicSets) {
                    <magic-collection-age-chart [magicCardStats]="magicCards" class="w-full"></magic-collection-age-chart>
                    <magic-collection-sets [magicCards]="magicCards" [magicSets]="magicSets" class="w-full"></magic-collection-sets>
                } @else {
                    <div class="text-slate-400 italics text-center">
                        No collection data found.
                    </div>
                }
            }
    </div>
</div>
}